import React from "react";
import { Card, Avatar, Button, Typography, Space, Descriptions, Progress } from "antd";
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

interface ProfileCardProps {
    name: string;
    role: string;
    employeeId: string;
    onTimePercentage: string;
    email: string;
    phone: string;
    location: string;
    avatar?: string;
    onViewProfile: () => void;
}


const ProfileCard: React.FC<ProfileCardProps> = ({
    name,
    role,
    employeeId,
    onTimePercentage,
    email,
    phone,
    location,
    avatar,
    onViewProfile,
}) => {

    return (
        <Card>
            <Space direction="horizontal">
                <Avatar shape="square" size={150} src={`${process.env.FILE_URL}${avatar}`} />
                <div style={{ flex: 1 }}>
                    <Title level={4} style={{ marginBottom: 0 }}>
                        {name}
                    </Title>
                    <Text type="secondary">{role}</Text>
                    <Space direction="vertical" size={"small"}>
                        <Descriptions>
                            <Descriptions.Item label="Employee ID">{employeeId}</Descriptions.Item>
                            <Descriptions.Item label="On Time">{onTimePercentage}%</Descriptions.Item>
                        </Descriptions>
                        <Space direction="horizontal" size="middle" style={{ width: "100%" }}>
                            <Text>
                                <MailOutlined /> {email}
                            </Text>
                            <Text>
                                <PhoneOutlined /> {phone}
                            </Text>
                            <Text>
                                <EnvironmentOutlined /> {location}
                            </Text>
                        </Space>
                        <Button
                            type="default"
                            onClick={onViewProfile}
                        >
                            View Profile
                        </Button>
                    </Space>
                </div>
            </Space>


        </Card>
    );
};

export default ProfileCard;
